import Application from "./Application";
import common from "./common";
import PreloaderScene from "./scenes/PreloaderScene";
import Brim from "./brim";
import screenfull from "screenfull";

export default class Main {
    /**
     * @param {number} [width=1024]
     * @param {number} [height=768]
     */
    constructor(width = 1024, height = 768) {
        this._width = width;
        this._height = height;
        this._app = null;
        this._preloader = null;
        this._printLoadProgress = true;
    }

    init() {
        P3.assets.audioFileTypes = ["ogg", "mp3"];
        P3.settings.WARN_TEXTURE_DIVISIBLE_BY_2 = false;
        P3.audio.preloadAudio = true;
        P3.input.refocus = false;

        PIXI.settings.RETINA_PREFIX = /_(?=[^_]*$)(.+)x/;
        PIXI.settings.MIPMAP_TEXTURES = false;
        PIXI.settings.STRICT_TEXTURE_CACHE = true;

        //common.tracking = new P3.tracking.Tracking(new P3.tracking.TrackingModuleGTag('UA-160662228-1'));

        typeof TweenMax !== "undefined" && (TweenMax.defaultOverwrite = "none");

        const options = {
            width: this._width,
            height: this._height,
            holderId: "game",
            portrait: false,
            rotateImageUrl: "./assets/images/rotate.jpg",
            rotateImageColor: "#000000",
            aspectRatioFillHeight: true
        };

        const view = new P3.View(options);
        view.signals.ready.once(function (canvas) {
            const options = {};
            options.view = canvas;
            options.transparent = false;
            options.antialias = false;
            options.preserveDrawingBuffer = false;
            options.resolution = 1;

            const stage = new PIXI.Container();
            common.stage = stage;

            P3.input.init(stage, canvas);

            //if (P3.utils.isCocoonJS()) {
            //stage.scale.x = window.innerHeight / this._height;
            //  stage.scale.y = window.innerHeight / this._height;
            //}

            var ua = window.navigator.userAgent;
            var isIE = /MSIE|Trident/.test(ua);

            let renderer;
            if (PIXI.Renderer) {

                if (isIE) {
                    renderer = new PIXI.CanvasRenderer(Object.assign(options, {
                        width: this._width, height: this._height
                    }));
                } else {
                    renderer = new PIXI.Renderer(Object.assign(options, {
                        width: this._width, height: this._height
                    }));
                }
                /*
                 renderer = new PIXI.Renderer(Object.assign(options, {
                     width: this._width, height: this._height
                 }));

                 */

            } else {
                renderer = !P3.utils.isCocoonJS() ?
                    PIXI.autoDetectRenderer(this._width, this._height, options) :
                    new PIXI.WebGLRenderer(window.innerWidth, window.innerHeight, options);
            }
            renderer.backgroundColor = 0x0;
            common.renderer = renderer;

            common.stage.addChild(P3.scene.view);

            const transitions = new PIXI.Container();
            common.stage.addChild(transitions);
            common.transitions = transitions;

            // deprecated
            //window.lasttweentime = 0;
            //window.tweendt = 0;

            PIXI.Ticker.shared.add((deltaTime) => {
                window.deltaTime = deltaTime / PIXI.settings.TARGET_FPMS / 1000;

                // deprecated
                //const currentTime = P3.utils.TWEEN.now();
                //window.tweendt = currentTime - window.lasttweentime;
                //window.lasttweentime = currentTime;

                P3.scene.update(window.deltaTime);
                P3.input.update();

                P3.utils.TWEEN.update();// comment this line out if you are using TweenMax

                renderer.render(stage);
            });

            /*
            if (PIXI.utils.isMobile.apple.device) {
                new Brim("assets/images/brim.jpg");
            }
             */

            /*
            if (screenfull.isEnabled) {
                setTimeout(() => screenfull.request(), 200);
            }
             */

            this.loadPreAssets();

        }, this);

        view.signals.resize.add(this.onCanvasResize, this);
        common.view = view;

        this.loadConfig(function () {
            view.init()
        }, this);    // we load the config before we do anything
    }

    loadConfig(callback, scope) {
        scope = scope || window;
        P3.assets.addFiles([{name: "config", url: "config" + ".json"}], "./");
        P3.assets.signals.complete.once(function () {
            common.config = P3.assets.json("config");
            callback && callback.call(scope);
        }, this);
        P3.assets.load();
    }

    loadPreAssets() {
        const files = [
            {name: "strings", url: "data/strings" + ".json"},
            {name: "preloader_1x", url: "images/preloader_1x" + ".json"},
            {name: "bg_preloader", url: "images/bg_preloader" + ".jpg"}
        ];
        if (files.length) {
            P3.assets.addFiles(files, "./assets/");
            P3.assets.signals.complete.once(this.loadAssets, this);
            P3.assets.load();
        } else {
            this.loadAssets();
        }
    }

    loadAssets() {

        common.strings = P3.assets.json("strings");

        const files = [
            //local
            {name: "title", url: "images/localization/title_" + (window.__language ? window.__language : common.config.language) + ".png"},
            {name: "logo", url: "images/localization/logo_game_title_en" + ".png"},
            //bg
            {name: "results_bg", url: "images/bg_end_screen" + ".jpg"},
            {name: "bg_choose_a_rocket_screen", url: "images/bg_choose_a_rocket_screen" + ".jpg"},
            {name: "bg_splash_screen", url: "images/bg_splash_screen" + ".jpg"},
            //sheets
            {name: "splash_1x", url: "images/splash_1x" + ".json"},
            {name: "ui_1x", url: "images/ui_1x" + ".json"},
            {name: "bg_0_1x", url: "images/bg_0_1x" + ".json"},
            {name: "bg_1_1x", url: "images/bg_1_1x" + ".json"},
            {name: "bg_2_1x", url: "images/bg_2_1x" + ".json"},
            //data
            {name: "bezier_01", url: "data/bezier_01" + ".json"},
            {name: "bezier_02", url: "data/bezier_02" + ".json"},
            {name: "bezier_03", url: "data/bezier_03" + ".json"},
            {name: "bezier_04", url: "data/bezier_04" + ".json"},
            {name: "bezier_05", url: "data/bezier_05" + ".json"},

            {name: "rocket_01_data", url: "data/rocket_01" + ".json"},
            {name: "rocket_02_data", url: "data/rocket_02" + ".json"},
            {name: "rocket_03_data", url: "data/rocket_03" + ".json"},
            {name: "rocket_04_data", url: "data/rocket_04" + ".json"},
            {name: "rocket_05_data", url: "data/rocket_05" + ".json"},
            {name: "rocket_06_data", url: "data/rocket_06" + ".json"},
            {name: "rocket_07_data", url: "data/rocket_07" + ".json"},
            {name: "rocket_08_data", url: "data/rocket_08" + ".json"},
            {name: "rocket_09_data", url: "data/rocket_09" + ".json"},
            {name: "rocket_10_data", url: "data/rocket_10" + ".json"},
            {name: "rocket_11_data", url: "data/rocket_11" + ".json"},
            {name: "rocket_12_data", url: "data/rocket_12" + ".json"},

            //spine
            {name: 'rocket_01', url: 'spine/rocket_01' + '.json'},
            {name: 'rocket_01_paths', url: 'spine/rocket_01_paths' + '.json'},

            {name: 'rocket_02', url: 'spine/rocket_02' + '.json'},
            {name: 'rocket_02_paths', url: 'spine/rocket_02_paths' + '.json'},

            {name: 'rocket_03', url: 'spine/rocket_03' + '.json'},
            {name: 'rocket_03_paths', url: 'spine/rocket_03_path' + '.json'},

            {name: 'rocket_04', url: 'spine/rocket_04' + '.json'},
            {name: 'rocket_04_paths', url: 'spine/rocket_04_path' + '.json'},

            {name: 'rocket_05', url: 'spine/rocket_05' + '.json'},
            {name: 'rocket_05_paths', url: 'spine/rocket_05_path' + '.json'},

            {name: 'rocket_06', url: 'spine/rocket_06' + '.json'},
            {name: 'rocket_06_paths', url: 'spine/rocket_06_path' + '.json'},

            {name: 'rocket_07', url: 'spine/rocket_07' + '.json'},
            {name: 'rocket_07_paths', url: 'spine/rocket_07_path' + '.json'},

            {name: 'rocket_08', url: 'spine/rocket_08' + '.json'},
            {name: 'rocket_08_paths', url: 'spine/rocket_08_path' + '.json'},

            {name: 'rocket_09', url: 'spine/rocket_09' + '.json'},
            {name: 'rocket_09_paths', url: 'spine/rocket_09_path' + '.json'},

            {name: 'rocket_10', url: 'spine/rocket_10' + '.json'},
            {name: 'rocket_10_paths', url: 'spine/rocket_10_path' + '.json'},

            {name: 'rocket_11', url: 'spine/rocket_11' + '.json'},
            {name: 'rocket_11_paths', url: 'spine/rocket_11_path' + '.json'},

            {name: 'rocket_12', url: 'spine/rocket_12' + '.json'},
            {name: 'rocket_12_paths', url: 'spine/rocket_12_path' + '.json'},

            // char spine
            {name: 'vfx_stars', url: 'spine/vfx_stars' + '.json'},
            {name: 'vfx_clash', url: 'spine/vfx_clash' + '.json'},
            {name: 'jerry', url: 'spine/jerry' + '.json'},
            {name: 'tom_side', url: 'spine/tom_side' + '.json'},

            //particles
            {name: "emitter_fire_00", url: "particles/emitter_fire_00" + ".json"},
            {name: "emitter_fire_01", url: "particles/emitter_fire_01" + ".json"},
            {name: "emitter_smoke", url: "particles/emitter_smoke" + ".json"},
            {name: "emitter_construction_00", url: "particles/particle_emitter_construction_00" + ".json"},
            {name: "emitter_launchpad_idle_00", url: "particles/particle_emitter_launchpad_idle_00" + ".json"},

            //audio
            {name: "sfx_click", url: "audio/sfx/sfx_click" + P3.assets.audioFileExt},
            {name: "sfx_rollover", url: "audio/sfx/sfx_rollover" + P3.assets.audioFileExt},
            {name: "sfx_negative", url: "audio/sfx/sfx_negative" + P3.assets.audioFileExt},
            {name: "sfx_positive", url: "audio/sfx/sfx_positive" + P3.assets.audioFileExt},
            {name: "sfx_drawing_fill_00", url: "audio/sfx/sfx_drawing_fill_00" + P3.assets.audioFileExt},
            {name: "sfx_drawing_loop_00", url: "audio/sfx/sfx_drawing_loop_00" + P3.assets.audioFileExt},

            {name: "sfx_change_colour_fill_00", url: "audio/sfx/sfx_change_colour_fill_00" + P3.assets.audioFileExt},
            {name: "sfx_chute_open_00", url: "audio/sfx/sfx_chute_open_00" + P3.assets.audioFileExt},
            {name: "sfx_construct_rocket", url: "audio/sfx/sfx_construct_rocket" + P3.assets.audioFileExt},
            {name: "sfx_crash_land_00", url: "audio/sfx/sfx_crash_land_00" + P3.assets.audioFileExt},
            {name: "sfx_erase_item_00", url: "audio/sfx/sfx_erase_item_00" + P3.assets.audioFileExt},
            {name: "sfx_next_design_page_00", url: "audio/sfx/sfx_next_design_page_00" + P3.assets.audioFileExt},
            {name: "sfx_paint_appears_00", url: "audio/sfx/sfx_paint_appears_00" + P3.assets.audioFileExt},
            {name: "sfx_rocket_launch_00", url: "audio/sfx/sfx_rocket_launch_00" + P3.assets.audioFileExt},
            {name: "sfx_select_design_00", url: "audio/sfx/sfx_select_design_00" + P3.assets.audioFileExt},
            {name: "sfx_tom_fall_00", url: "audio/sfx/sfx_tom_fall_00" + P3.assets.audioFileExt},
            {name: "sfx_ambient_birds_00", url: "audio/sfx/sfx_ambient_birds_00" + P3.assets.audioFileExt},
            {name: "sfx_rocket_flight_loop_02", url: "audio/sfx/sfx_rocket_flight_loop_02" + P3.assets.audioFileExt},

            {name: "sfx_flyby_crow_00", url: "audio/sfx/sfx_flyby_crow_00" + P3.assets.audioFileExt},
            {name: "sfx_flyby_crow_01", url: "audio/sfx/sfx_flyby_crow_01" + P3.assets.audioFileExt},
            {name: "sfx_flyby_hot_air_balloon_00", url: "audio/sfx/sfx_flyby_hot_air_balloon_00" + P3.assets.audioFileExt},
            {name: "sfx_flyby_jet_plane_flyby_00", url: "audio/sfx/sfx_flyby_jet_plane_flyby_00" + P3.assets.audioFileExt},

            {name: "sfx_rocket_prelaunch_00", url: "audio/sfx/sfx_rocket_prelaunch_00" + P3.assets.audioFileExt},
            {name: "sfx_button_slam_00", url: "audio/sfx/sfx_button_slam_00" + P3.assets.audioFileExt},

            {name: "music_flight_loop_00", url: "audio/music/music_flight_loop_00" + P3.assets.audioFileExt},
            {name: "music_flight_loop_01", url: "audio/music/music_flight_loop_01" + P3.assets.audioFileExt},
            {name: "music_flight_loop_02", url: "audio/music/music_flight_loop_02" + P3.assets.audioFileExt},
            {name: "music_flight_loop_03", url: "audio/music/music_flight_loop_03" + P3.assets.audioFileExt},
            {name: "music_flight_loop_04", url: "audio/music/music_flight_loop_04" + P3.assets.audioFileExt},
            {name: "music_flight_loop_05", url: "audio/music/music_flight_loop_05" + P3.assets.audioFileExt},

            {name: "music_garage_drawing_loop_00", url: "audio/music/music_garage_drawing_loop_00" + P3.assets.audioFileExt},
            {name: "music_menu_loop_00", url: "audio/music/music_menu_loop_00" + P3.assets.audioFileExt},
            {name: "music_parachute_release_00", url: "audio/music/music_parachute_release_00" + P3.assets.audioFileExt},
            {name: "music_parachute_release_01", url: "audio/music/music_parachute_release_01" + P3.assets.audioFileExt},
            {name: "music_tom_landing_00", url: "audio/music/music_tom_landing_00" + P3.assets.audioFileExt},
            {name: "music_tom_landing_01", url: "audio/music/music_tom_landing_01" + P3.assets.audioFileExt},
            {name: "music_tom_to_rocket_00", url: "audio/music/music_tom_to_rocket_00" + P3.assets.audioFileExt},
        ];

        if (files.length) {
            this._preloader = new PreloaderScene();
            P3.scene.show(this._preloader);

            P3.assets.addFiles(files, "./assets/");
            P3.assets.signals.progress.add(this.onLoadingProgress, this);
            P3.assets.signals.complete.once(this.onLoadingCompleted, this);
            P3.assets.load();
        } else {
            this.start();
        }
    }

    start() {
        this._app = new Application();
        this._app.init();
    }

    onLoadingProgress(event) {
        this._preloader && (this._preloader.loaded = event.progress / 100);
        this._printLoadProgress && console.log("loading:", Math.floor(event.progress));
    }

    onLoadingCompleted() {
        this._preloader && (this._preloader.loaded = 1);
        setTimeout(() => this.start(), 440);
    }

    onCanvasResize(correct) {
        if (correct) {
            common.renderer.resize(P3.View.width, P3.View.height);
            if (P3.scene) {
                P3.scene.resize();

                for (let i = 0; i < common.transitions.children.length; ++i) {
                    const transition = common.transitions.children[i];
                    transition.resize && transition.resize();
                }
            }
        }
    }
}
